import { createCollectionStatusLink } from "@/router";
import { RouteName } from "@/router/routeNameEnum";
import { ItemStatus } from "@/services/collection/item";
import { ItemStatusUrlString } from "@/services/collection/collectionUrl";
import type { RouteLocationNormalized } from "vue-router";

export const createArchiveLink = () => createCollectionStatusLink(ItemStatus.Deleted);

export const createMyCollectionMarketplaceItemsLink = () => createCollectionStatusLink(ItemStatus.OnMarketplace);

export const createMyCollectionLink = () => createCollectionStatusLink(ItemStatus.InMyCollection);

export const isArchiveRoute = (route: RouteLocationNormalized): boolean => {
  const isCollectionRoute = route.name === RouteName.Collection;
  const isArchiveFilter = route.params.itemStatus === ItemStatusUrlString.Deleted;
  return isCollectionRoute && isArchiveFilter;
};
